import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-my-course-lesson-quiz-route.tsx
var LazyMyCourseLessonQuizRoute = lazy(() => import("./my-course-lesson-quiz-route-Z066dIAS.js").then((n) => n.n).then((module) => ({ default: module.MyCourseLessonQuizRoute })));
function MyCourseLessonQuizRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseLessonQuizRoute, { ...props })
	});
}
var useMyCourseLessonQuizRoute = () => {
	return useMemo(() => ({ "my-course-lesson-quiz-route": { component: MyCourseLessonQuizRoute } }), []);
};
//#endregion
export { useMyCourseLessonQuizRoute };
